import { Menu, ActionIcon } from "@mantine/core";
import { IconQuote } from "@tabler/icons-react";

const PLACEHOLDERS = [
  { label: "First Name", value: "{{ firstName }}" },
  { label: "Last Name", value: "{{ lastName }}" },
  { label: "Email", value: "{{ email }}" },
  { label: "Event Name", value: "{{ eventName }}" },
];

// Body-only placeholders, offered in the editor body but not in the subject
// field: the workspace name, and each holder's own ticket code and the link
// that opens the ticket.
const BODY_PLACEHOLDERS = [
  { label: "Workspace Name", value: "{{ workspaceName }}" },
  { label: "Ticket Code", value: "{{ claimCode }}" },
  { label: "Ticket Link", value: "{{ claimLink }}" },
];

const PlaceholderMenu = ({ onInsert, menuIcon, includeWorkspace = false }) => {
  const placeholders = includeWorkspace
    ? [...PLACEHOLDERS, ...BODY_PLACEHOLDERS]
    : PLACEHOLDERS;

  return (
    <Menu shadow="md" width={180}>
      <Menu.Target>
        {menuIcon ?? (
          <ActionIcon
            variant="outline"
            color="gray"
            size="sm"
            aria-label="Insert placeholder"
            title="Insert placeholder"
          >
            <IconQuote size={16} />
          </ActionIcon>
        )}
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Insert placeholder</Menu.Label>
        {placeholders.map((p) => (
          <Menu.Item key={p.value} onClick={() => onInsert(p.value)}>
            {p.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default PlaceholderMenu;
